export function formatPrice(price, city) {
  if (price === null || price === undefined) return '';

  let locale = 'de-DE';
  let currency = 'EUR';

  if (city === 'Prague') {
    locale = 'cs-CZ';
    currency = 'CZK';
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(price));
}

export function formatNumber(price) {
  if (price === null || price === undefined) return '';

  // Convert to number and format with German locale
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
}